'use client';

import { Box } from '@mui/material';
import { NotLoginView } from '@repo-ui/components/NotLoginView';
import { PageBanner } from '@repo-ui/components/PageBanner';
import { routerPushI18n } from '@repo-ui/router';
import { useLoginUser } from '@repo-ui/store/useAuthStore';
import { BreedUtil } from '@repo-ui/util/BreedUtil';
import { useLocale } from 'next-intl';
import { MyProjectList } from './components/MyProjectList';

const BANNER_TINT = '#0B77C7';
const BANNER_BACKGROUND = '#121212';

const BANNER_TABS = [
  { key: 'blk', label: '블록 코딩' },
  { key: 'text', label: '텍스트 코딩' },
] as const;

interface Props {
  tabKey?: (typeof BANNER_TABS)[number]['key'];
}

export default function MyProjectListFeature(props: Props) {
  const { tabKey = BANNER_TABS[0].key } = props;
  const locale = useLocale();
  const { isLoggedIn, loginAccountId } = useLoginUser();

  return (
    <Box className="MyProjectListFeature-root" sx={{ pb: 8 }}>
      <PageBanner
        title="나의 코딩"
        tint={BANNER_TINT}
        background={BANNER_BACKGROUND}
        contrastColor="#fff"
        bgImgSrc="/_static/images/page-banner/top_banner3.png"
        tabKey={tabKey}
        tabs={BANNER_TABS}
        breadcrumbProps={{
          tint: '#fff',
          section: '코딩',
          currentTitle: '나의 코딩',
        }}
        onChangeTab={(_, value) => {
          if (value !== tabKey) {
            routerPushI18n(`/coding/mine`, value);
          }
        }}
      />

      {isLoggedIn && tabKey === 'blk' && (
        <MyProjectList
          key={loginAccountId}
          sx={{ maxWidth: 'md', mx: 'auto', mt: 6 }}
          breeds={BreedUtil.blkTypeBreeds}
        />
      )}

      {isLoggedIn && tabKey === 'text' && (
        <MyProjectList
          key={loginAccountId}
          sx={{ maxWidth: 'md', mx: 'auto', mt: 6 }}
          breeds={BreedUtil.textTypeBreeds}
        />
      )}

      <NotLoginView hidden={isLoggedIn} />
    </Box>
  );
}
